import Reveal from "@/components/base/Reveal";
import { brandLogosImage } from "@/mocks/site";

export default function BrandsSection() {
  return (
    <section className="bg-background-50 px-4 md:px-10 py-16 md:py-24">
      <Reveal className="text-center">
        <h2 className="font-heading text-2xl md:text-4xl tracking-tight text-foreground-950">
          TRUSTED BY LEADING BRANDS.
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600">
          Award-winning work. Long-term partnerships. Real results.
        </p>
      </Reveal>

      <Reveal delay={120} className="mt-10 md:mt-14">
        <img
          src={brandLogosImage}
          alt="A collage of client logos including Adidas, Kawasaki, Adventist Health, Raley's, Sonoma Clean Power, Russian River Brewing Company, Providence, Ridge Vineyards, Trinchero Family Estates, Luther Burbank Center for the Arts, and Exchange Bank."
          title="Definition Films client logos"
          className="mx-auto h-auto w-full max-w-5xl"
        />
      </Reveal>
    </section>
  );
}